/** Custom field datatypes that store one record's id and show the record's current name. */
export const RECORD_ID_DATATYPES = ['Contact', 'Account', 'Product'];
